import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect } from "react";
import { getDates } from "./helpers/getDates.js";
import { getDays } from "./helpers/getDays.js";
import { getDisplayMonths } from "./helpers/getDisplayMonths.js";
import { getInitialMonth } from "./helpers/getInitialMonth.js";
import { getMonths } from "./helpers/getMonths.js";
import { getNavMonths } from "./helpers/getNavMonth.js";
import { getNextMonth } from "./helpers/getNextMonth.js";
import { getPreviousMonth } from "./helpers/getPreviousMonth.js";
import { getWeeks } from "./helpers/getWeeks.js";
import { useControlledValue } from "./helpers/useControlledValue.js";
/** @private */
export function useCalendar(props, dateLib) {
  var _getNavMonths = getNavMonths(props, dateLib),
    _getNavMonths2 = _slicedToArray(_getNavMonths, 2),
    navStart = _getNavMonths2[0],
    navEnd = _getNavMonths2[1];
  var startOfMonth = dateLib.startOfMonth,
    endOfMonth = dateLib.endOfMonth;
  var initialMonth = getInitialMonth(props, dateLib);
  var _useControlledValue = useControlledValue(initialMonth,
    // initialMonth is always computed from props.month if provided
    props.month ? initialMonth : undefined),
    _useControlledValue2 = _slicedToArray(_useControlledValue, 2),
    firstMonth = _useControlledValue2[0],
    setFirstMonth = _useControlledValue2[1];
  useEffect(function () {
    var newInitialMonth = getInitialMonth(props, dateLib);
    setFirstMonth(newInitialMonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.timeZone]);
  /** The months displayed in the calendar. */
  var displayMonths = getDisplayMonths(firstMonth, navEnd, props, dateLib);
  /** The dates displayed in the calendar. */
  var dates = getDates(displayMonths, props.endMonth ? endOfMonth(props.endMonth) : undefined, props, dateLib);
  /** The Months displayed in the calendar. */
  var months = getMonths(displayMonths, dates, props, dateLib);
  /** The Weeks displayed in the calendar. */
  var weeks = getWeeks(months);
  /** The Days displayed in the calendar. */
  var days = getDays(months);
  var previousMonth = getPreviousMonth(firstMonth, navStart, props, dateLib);
  var nextMonth = getNextMonth(firstMonth, navEnd, props, dateLib);
  var disableNavigation = props.disableNavigation,
    onMonthChange = props.onMonthChange;
  var isDayInCalendar = function isDayInCalendar(day) {
    return weeks.some(function (week) {
      return week.days.some(function (d) {
        return d.isEqualTo(day);
      });
    });
  };
  var goToMonth = function goToMonth(date) {
    if (disableNavigation) {
      return;
    }
    var newMonth = startOfMonth(date);
    // if month is before start, use the first month instead
    if (navStart && newMonth < startOfMonth(navStart)) {
      newMonth = startOfMonth(navStart);
    }
    // if month is after endMonth, use the last month instead
    if (navEnd && newMonth > startOfMonth(navEnd)) {
      newMonth = startOfMonth(navEnd);
    }
    setFirstMonth(newMonth);
    onMonthChange === null || onMonthChange === void 0 || onMonthChange(newMonth);
  };
  var goToDay = function goToDay(day) {
    // is this check necessary?
    if (isDayInCalendar(day)) {
      return;
    }
    goToMonth(day.date);
  };
  var calendar = {
    months: months,
    weeks: weeks,
    days: days,
    navStart: navStart,
    navEnd: navEnd,
    previousMonth: previousMonth,
    nextMonth: nextMonth,
    goToMonth: goToMonth,
    goToDay: goToDay
  };
  return calendar;
}